import { render, staticRenderFns } from "./AddPeriodModal.vue?vue&type=template&id=5f1e8522&scoped=true&"
import script from "./AddPeriodModal.vue?vue&type=script&lang=js&"
export * from "./AddPeriodModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1e8522",
  null
  
)

export default component.exports